<mat-card appearance="outlined" class="pigeon-video-card">
  <button
    class="btn-close"
    mat-icon-button
    color="primary"
    (click)="onCloseVideo()">
    <i class="far fa-times fa-lg"></i>
  </button>
  <iframe
    [src]="urlTutorialVideo()"
    frameborder="0"
    allowfullscreen
    width="700"
    height="450"></iframe>
</mat-card>
